<template>
  <div>
    <el-dialog
      title="Insert channel"
      :visible="dialog_insert"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialogInsert(false)"
    >
      <el-form label-position="top">
        <el-form-item label="Channel" prop="channel">
          <el-input type="text" v-model="channel" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      channel: ''
    }
  },
  computed: {
    ...mapState('youtubeWhitelist', ['dialog_insert', 'loading'])
  },

  methods: {
    ...mapActions('youtubeWhitelist', ['insert']),
    ...mapMutations('youtubeWhitelist', ['setDialogInsert']),

    submit() {
      this.insert(this.channel)
      this.setDialogInsert(false)
      this.channel = ''
    }
  }
}
</script>
